import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { CalenderDayHitch, DriversHitchCalendarDay } from '../../types';

@Component({
  selector: 'lohi-calendar-day-details',
  templateUrl: './calendar-day-details.component.html',
  styleUrls: [],
})
export class CalendarDayDetailsComponent implements OnInit {
  public hitchesToday$$ = new BehaviorSubject<CalenderDayHitch[]>(null);

  constructor(
    public dialogRef: MatDialogRef<CalendarDayDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DriversHitchCalendarDay,
  ) {}

  public ngOnInit() {
    this.hitchesToday$$.next([
      ...this.data.hitchesFullDay,
      ...this.data.hitchesEndingToday,
      ...this.data.hitchesStartingToday,
    ]);
  }
}
